/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CameraIntrinsicsFromJSON, CameraIntrinsicsToJSON, StreemApiPointFromJSON, StreemApiPointToJSON, StreemApiPoseFromJSON, StreemApiPoseToJSON, } from './';
export function StreemApiArtifactStreemshotSourceFromJSON(json) {
    return StreemApiArtifactStreemshotSourceFromJSONTyped(json, false);
}
export function StreemApiArtifactStreemshotSourceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': !exists(json, 'url') ? undefined : json['url'],
        'pose': !exists(json, 'pose') ? undefined : StreemApiPoseFromJSON(json['pose']),
        'featurePoints': !exists(json, 'feature_points') ? undefined : (json['feature_points'].map(StreemApiPointFromJSON)),
        'cameraIntrinsics': !exists(json, 'camera_intrinsics') ? undefined : CameraIntrinsicsFromJSON(json['camera_intrinsics']),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}
export function StreemApiArtifactStreemshotSourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'pose': StreemApiPoseToJSON(value.pose),
        'feature_points': value.featurePoints === undefined ? undefined : (value.featurePoints.map(StreemApiPointToJSON)),
        'camera_intrinsics': CameraIntrinsicsToJSON(value.cameraIntrinsics),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}
//# sourceMappingURL=StreemApiArtifactStreemshotSource.js.map